import { render, staticRenderFns } from "./basicInfoAgentList.vue?vue&type=template&id=01b0578f&scoped=true"
import script from "./basicInfoAgentList.vue?vue&type=script&lang=js"
export * from "./basicInfoAgentList.vue?vue&type=script&lang=js"
import style0 from "./basicInfoAgentList.vue?vue&type=style&index=0&id=01b0578f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0578f",
  null
  
)

export default component.exports